function ErrorControl({ show, error }) {

  return (<>{show &&
    <div
      style={{
        padding: "10px",
        borderRadius: "5px",
        margin: "10px",
        border: "1px solid #be0000",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
        background: "#faa6a6",
        color: "red",
        fontSize: "16px",
        fontWeight: "bold",
      }}>
      {error}
    </div>}</>

  );
}

export default ErrorControl;
